angular.module('unergie.main')
.filter('accountId', () =>
    function (val) {
        if (val && (val.length > 8)) {
            return `${val.slice(0, 8)}...`
        }
        return val
    },
)
